import {PAGINATOR_LOCALE_ES} from "../../shared/crud-table";
import {USER_MANAGEMENT_LOCALE_ES} from "../../modules/user-management/i18n/locale";
import {I18N_PARTIALS_ES} from "../partials/es";
import {GROUP_MANAGEMENT_LOCALE_ES} from "../../modules/group-management/i18n/locale";
import {ILangVocab} from "../interface";
import {CENTER_MANAGEMENT_LOCALE_ES} from "../../modules/center-management/i18n/locale";
import {PATIENT_MANAGEMENT_LOCALE_ES} from "../../modules/patient-management/i18n/locale";
import {PROFESSIONAL_MANAGEMENT_LOCALE_ES} from "../../modules/professional-management/i18n/locale";
import {GAME_SESSION_LOCALE_ES} from "../../modules/game-session/i18n/locale";
import {ADMINISTRATOR_CENTER_LOCALE_ES} from "../../modules/administrator-center-management/i18n/locale";

export const locale: ILangVocab = {
  lang: 'es',
  data: {
    TRANSLATOR: {
      SELECT: 'Elige tu idioma',
    },
    MENU: {
      DASHBOARD: 'Tablero'
    },
    TEXT: {
      MANAGEMENT: 'Gestión',
      ADMINISTRATION: 'Administración',
      SELECT: 'Seleccionar',
      ONLINE_TITLE: 'Conexión restablecida',
      ONLINE_MESSAGE: 'Vuelve a estar en línea.',
      OFFLINE_TITLE: '¡Conexión perdida!',
      OFFLINE_MESSAGE: 'No estas conectado a internet.',
      NO_ITEMS_FOUND: 'No se encontraron elementos',
    },
    ROLE: {
      ADMIN_CENTER: 'Gestor de centro',
      ADMIN: 'Super Admin',
      PATIENT: 'Paciente',
      PROFESSIONAL: 'Profesional'
    },
    GENDER: {
      MALE: 'Masculino',
      FEMALE: 'Femenino',
      INTERSEXUAL: 'Intersexual',
      OTHER: 'Prefiero no decir',
    },
    //TODO: Adicionar los translations del modulo auth
    ...I18N_PARTIALS_ES,
    ...PAGINATOR_LOCALE_ES,
    ...USER_MANAGEMENT_LOCALE_ES,
    ...GROUP_MANAGEMENT_LOCALE_ES,
    ...CENTER_MANAGEMENT_LOCALE_ES,
    ...PATIENT_MANAGEMENT_LOCALE_ES,
    ...PROFESSIONAL_MANAGEMENT_LOCALE_ES,
    ...GAME_SESSION_LOCALE_ES,
    ...ADMINISTRATOR_CENTER_LOCALE_ES
  }
};
